<template>
    <div class="text-center">
        <v-progress-circular indeterminate color="primary" class="mr-3" v-if="loading" />
        <template v-else>
            <v-window v-model="currentStep" class="mx-2">
                <v-window-item value="selectUser">
                    <v-row no-gutters style="flex-wrap: nowrap" class="pb-2">
                        <v-col class="d-flex pr-2 pt-3">
                            <v-text-field-filled
                                v-model="searchUser"
                                label="Rechercher"
                                outlined
                                hide-details
                                data-cy="SelectUser-recherche"
                                density="compact"
                                append-inner-icon="$search"
                                clearable
                                @click:clear="searchUser = ''"
                            />
                        </v-col>
                    </v-row>
                    <v-list subheader :style="`height: ${height} ; overflow-y: auto`" lines="two">
                        <template v-for="(user, i) in filtredUsers" :key="i">
                            <v-list-item
                                v-if="!multiple"
                                :class="getUserItemClass(user.id)"
                                @click="!multiple ? selectUser(user) : null"
                                :data-cy="'selectUser-user-' + i"
                                rounded="xl"
                                density="compact"
                            >
                                <template #prepend>
                                    <v-avatar color="secondary">
                                        {{ getUserBigram(user) }}
                                    </v-avatar>
                                </template>
                                <v-list-item-title>
                                    {{ getUserDisplayName(user) }}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="user.email">{{
                                    user.email
                                }}</v-list-item-subtitle>

                                <template #append>
                                    <v-btn-icon
                                        :icon="
                                            user.id === selectedUserId
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        "
                                    >
                                    </v-btn-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-else
                                :class="getUserItemClass(user.id)"
                                @click="!multiple ? selectUser(user) : null"
                                :data-cy="'selectUser-user-' + i"
                                rounded="xl"
                                density="compact"
                            >
                                <template v-slot:append>
                                    <v-checkbox
                                        v-model="selectedUsers"
                                        class="pa-0 ma-0"
                                        :value="user.id"
                                    />
                                </template>

                                <v-list-item-title>
                                    {{ getUserDisplayName(user) }}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="user.email">{{
                                    user.email
                                }}</v-list-item-subtitle>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-window-item>
            </v-window>
        </template>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";
import COMPANYUSERS2 from "../../graphql/user/PartOfCompanyUsers2.gql";
import OUTSTANDING_USERS from "../../graphql/auth/OutstandingUsers.gql";

import { getUserBigram, getUserDisplayName } from "../../services/userServices";
import { User } from "../../store/store";
import { Component, Vue, toNative, Model } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["user-selected", "update:step", "isValidUser"],
})
export class SelectUser extends Vue {
    @Prop({ default: "" }) readonly companyId: string;
    @Prop({ default: "" }) readonly availableCompanyId: string;
    @Prop({ default: undefined }) readonly selectedUser: any;
    @Prop({ default: undefined }) readonly type: string;
    @Prop({ default: "60vh" }) readonly height: string;
    @Prop({ default: null }) actions: any;
    @Prop({ default: "" }) readonly outstanding: string;
    @Prop({ default: false }) readonly multiple: boolean;
    @Prop({ default: "" }) step: string;
    @Prop({ default: null }) withEmail: boolean;
    @Prop({ default: null }) autoSelect: boolean;

    @Model() value;

    searchUser = "";

    step_ = "selectUser";

    isValidUserCreation_ = false;

    get currentStep() {
        if (this.step) return this.step;
        return this.step_;
    }

    set currentStep(value) {
        this.step_ = value;
        this.$emit("update:step", value);
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isValidUserCreation() {
        return this.isValidUserCreation_;
    }

    set isValidUserCreation(data) {
        this.isValidUserCreation_ = data;
        this.$emit("isValidUser", data);
    }

    get filtredUsers() {
        if (!this.searchUser) {
            return this.users;
        }
        return this.users.filter((user) =>
            getUserDisplayName(user).toLowerCase().includes(this.searchUser.toLowerCase()),
        );
    }

    get loading() {
        if (this.$apollo.queries.users) {
            return this.$apollo.queries.users.loading;
        }
        return false;
    }

    get selectedUserId() {
        if (this.user) {
            return this.user.id;
        }

        return "";
    }

    get user() {
        if (this.selectedUser) return this.selectUser;
        return this.value;
    }

    get selectedUsers() {
        if (this?.value?.length) return this.value.map((u) => u.id);
        return [];
    }

    set selectedUsers(value) {
        debugger;
        const usersSelected = this.users.filter((user) => value.includes(user.id));
        this.value = usersSelected;
    }

    get isInList() {
        if (this.user) {
            return !!this.users.find((u) => u.id === this.user.id);
        }
        return true;
    }

    @Apollo({
        query() {
            return this.availableCompanyId ? COMPANYUSERS2 : COMPANY_USERS;
        },
        variables() {
            return {
                companyId: this.companyId,
                type: this.type,
                email_not: this.withEmail ? null : undefined,
                availableCompanyId: this.availableCompanyId,
            };
        },
        skip() {
            return !this.companyId || !!this.outstanding;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.users) {
                    // debugger
                    this.dbUsers = JSON.parse(JSON.stringify(data.users));
                    if (this.user?.id) {
                        debugger;
                        if (!this.isInList) {
                            data.users.push(this.user);
                        }
                    } else if (this.autoSelect) {
                        this.autoSelectFunction();
                    }
                } else {
                    this.dbUsers = [];
                    this.selectUser({});
                }
            }
        },
    })
    dbUsers: [] = [];

    @Apollo({
        query: OUTSTANDING_USERS,
        variables() {
            return {
                companyId: this.companyId,
                outstanding: this.outstanding,
            };
        },
        skip() {
            return !this.companyId || !this.outstanding;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.outstandingUsers) {
                    // debugger
                    this.outstandingUsers = JSON.parse(JSON.stringify(data.outstandingUsers));
                    if (this.user && this.user.id) {
                        if (!this.isInList) {
                            this.outstandingUsers.push(this.user);
                        }
                    }
                } else {
                    this.outstandingUsers = [];
                    this.selectUser({});
                }
            }
        },
    })
    outstandingUsers: User[] = [];

    get users() {
        if (this.outstanding) {
            return this.outstandingUsers;
        }
        return this.dbUsers;
    }

    autoSelectFunction() {
        const currentUserInUserList = this.users.find((u) => u.id === this.currentUser.id);
        if (currentUserInUserList) {
            this.selectUser(currentUserInUserList);
        }
    }

    getUserBigram(user) {
        return getUserBigram(user);
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    selectUser(user) {
        this.$emit("user-selected", user);
        this.value = user;
    }

    getUserItemClass(userId) {
        let userClass = "oss-list-item mb-2";
        if (userId === this.selectedUserId) userClass += " oss-list-item-selected";
        return userClass;
    }

    upsertUser(redirect = false) {
        // @ts-ignore
        this.$refs.userEdition.upsertUser(redirect);
        if (!redirect === false) {
            this.currentStep = "selectUser";
        }
    }
}

export default toNative(SelectUser);
</script>
